import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import Button, { ButtonSize, ButtonVariant } from 'components/Button';
import FXProviderIcon from 'assets/icons/connectors/FXProvider.svg';
import { Input } from 'components/Inputs';
import Modal from 'components/Modal';

const RequestProviderModal = ({ onClose, onSuccess }) => {
  const { t } = useTranslation('integration');

  const [provider, setProvider] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleChange = (e) => {
    setProvider(e.target.value);
  };

  const handleClick = () => {
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      onSuccess();
    }, 2000);
  };

  return (
    <Modal
      isOpen={true}
      closeModal={onClose}
      maxWidth="32rem"
      isOverlayDisabled
    >
      <>
        <div className="px-6 pb-8 pt-14">
          <img src={FXProviderIcon} alt="FX Provider" className="mx-auto" />
          <p className="mt-8 text-lg font-medium text-center">
            {t('fxProvider.request.title')}
          </p>
          <p className="mt-2 mb-8 text-secondary text-center">
            {t('fxProvider.request.text')}
          </p>
          <Input
            name="provider"
            label={t('fxProvider.request.label')}
            value={provider}
            onChange={handleChange}
          />
        </div>
        <div className="px-6 py-5 border-t border-gray-200 flex items-center justify-center gap-6">
          <Button
            variant={ButtonVariant.secondaryOutline}
            size={ButtonSize.mediumLarge}
            className="flex-1"
            heightClass="h-11"
            onClick={onClose}
          >
            <span className="font-semibold">{t('common:cancel')}</span>
          </Button>
          <Button
            size={ButtonSize.mediumLarge}
            className="flex-1"
            heightClass="h-11"
            disabled={!provider}
            onClick={handleClick}
            loading={isLoading}
          >
            {t('fxProvider.request.button')}
          </Button>
        </div>
      </>
    </Modal>
  );
};

export default RequestProviderModal;
